/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

var dividerDefaultProps = {
  align: "center",
  dashed: false,
  layout: "horizontal"
};

export { dividerDefaultProps };
//# sourceMappingURL=defaultProps.js.map
